import { useState } from "react";

const BASE_URL =
  process.env.REACT_APP_API_BASE_URL || "http://localhost/gmt-api";

export default function ForgotPassword() {
  const [forgotEmail, setForgotEmail] = useState("");
  const [forgotLoading, setForgotLoading] = useState(false);
  const [forgotMsg, setForgotMsg] = useState("");

  const handleForgotPassword = async (e) => {
    e.preventDefault();

    if (!forgotEmail.trim()) return;

    setForgotLoading(true);
    setForgotMsg("");

    try {
      const res = await fetch(`${BASE_URL}/auth/forgot-password.php`, {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email: forgotEmail }),
      });

      const data = await res.json();

      if (!res.ok || !data.status) {
        throw new Error(data.message || "Unable to process request");
      }

      setForgotMsg("If this email exists, a reset link has been sent.");
    } catch (err) {
      setForgotMsg(err.message || "Something went wrong.");
    } finally {
      setForgotLoading(false);
    }
  };

  return (
    <div className="auth-page">
      <form onSubmit={handleForgotPassword} className="auth-card">
        <h2>Forgot Password</h2>

        <input
          type="email"
          value={forgotEmail}
          onChange={(e) => setForgotEmail(e.target.value)}
          placeholder="Enter your email"
          required
        />

        {forgotMsg && <p>{forgotMsg}</p>}

        <button type="submit" disabled={forgotLoading}>
          {forgotLoading ? "Sending..." : "Send Reset Link"}
        </button>
      </form>
    </div>
  );
}